export const VERSION_NUMBER = '8.0.684'
export const DEFAULT_ALLOWED_DOWNLOAD_COUNT = 8;
export const PAGE_SIZE_OPTIONS = [50, 25, 10];
export const DEFAULT_TAKE = PAGE_SIZE_OPTIONS[0];

export const makeSlug = (str: string) => str.toLowerCase().replace(/[\W_]+/g," ").trim().replace(/ /g,"_")

export const ARTIST_STATUS_CD = {
    ACTIVE: 'Active Roster',
    PVFULL: 'Full Roster',
    NONPV: 'Not Roster',
    INACTIVE: 'Inactive',
}

export const SHIPPING_TYPE_CD = {
    USPS: {
        label: 'US Mail',
        url: 'https://tools.usps.com/go/TrackConfirmAction.action?tRef=fullpage&tLc=1&text28777=&tLabels='
    },
    INTERNATIONAL: {
        label: 'International',
        url: ''
    },
    FEDEX: {
        label: 'FedEx',
        url: 'https://www.fedex.com/fedextrack/?trknbr='
    },
    FLAT: {
        label: 'Flat Rate',
        url: 'https://tools.usps.com/go/TrackConfirmAction.action?tRef=fullpage&tLc=1&text28777=&tLabels='
    },
    FREE: {
        label: 'FREE',
        url: 'https://www.fedex.com/fedextrack/?trknbr='
    }
}

export const EMPTY_CONTENT_IMAGE = 'https://polyvinyl-public.s3.amazonaws.com/ddfd73da687b249d8b59329addb805aeb5be63fa_3252c92422e22823e60bd75be395a5003c53478c_thumb_png'


export const resourceDict = {
    fuga: {
        title: 'Fuga',
        api: 'fuga/cms',
        name: 'fuga',
        route: 'fuga',
    },
    releaseProduct: {
        title: 'Release Products',
        api: 'release-product/cms',
        name: 'release_product',
        route: 'release-product',
        edit: true,
    },
    releaseProdList: {
        title: 'Release Product Lists',
        api: 'release-prod-list/cms',
        name: 'release_prod_list',
        route: 'release-prod-list',
        edit: true,
    },
    release: {
        title: 'Releases',
        api: 'release/cms',
        name: 'release',
        route: 'release',
        edit: true,
        autocomplete: {
            placeholder: 'Search for a release',
            foreign_key: true,
            initializeEmpty: true,
        }
    },
    accountStyles: {
        title: 'Account Styles',
        api: 'account-styles/cms',
        name: 'account_style',
        route: 'account-styles',
        edit: true,
    },
    sellingChannel: {
        title: 'Selling Channel',
        api: 'selling-channel/cms',
        name: 'selling-channel',
        route: 'selling-channel',
        edit: true,
        back: true,
        autocomplete: {
            placeholder: 'Select a Selling Channel',
            bindLabel: 'name',
            foreign_key: true,
            initializeEmpty: true,
            path: 'selling-channel'
        },
    },
    bigcartelAccount: {
        title: 'BigCartel',
        api: 'bigcartel/cms',
        route: 'bigcartel',
        name: 'bigcartel_account',
    },
    productInstanceNotification: {
        title: 'Back In Stock Notifications',
        api: 'product-instance-notification/cms',
        route: 'product-instance-notification',
        name: 'instance_notification',
    },
    performer: {
        title: 'Performers',
        api: 'performer/cms',
        route: 'performer',
        name: 'performer',
    },
    songwriter: {
        title: 'Songwriters',
        api: 'songwriter/cms',
        route: 'songwriter',
        name: 'songwriter',
    },
    alert: {
        title: 'Alerts',
        api: 'alert/cms',
        route: 'alert',
        name: 'alert',
        edit: true,
    },
    publisher: {
        title: 'Publishers',
        api: 'publisher/cms',
        route: 'publisher',
        name: 'publisher',
        newScreenAdd: true,
        edit: true,
        autocomplete: {
            foreign_key: true,
            initializeEmpty: true,
        }
    },
    salesTax: {
        title: 'Sales Tax',
        api: 'sales-tax/cms',
        route: 'sales-tax',
        name: 'sales_tax'
    },
    mailchimp: {
        title: 'Mailchimp',
        api: 'mailchimp/cms',
        route: 'mailchimp',
        name: 'mailchimp'
    },
    spotifyArtist: {
        title: 'Spotify Artists',
        api: 'spotify/cms/artist',
        route: null,
        name: 'spotify_artist',
        autocomplete: {
            bindLabel: 'text',
            initializeEmpty: false,
            foreign_key: false,
            placeholder: 'Lookup an Artist'
        }
    },
    spotifyAlbum: {
        title: 'Spotify Albums',
        api: 'spotify/cms/album',
        route: null,
        name: 'spotify_album',
        autocomplete: {
            bindLabel: 'text',
            initializeEmpty: false,
            foreign_key: false,
            placeholder: 'Lookup an Album'
        }
    },
    address: {
        title: 'Customer Addresses',
        api: 'address/cms',
        route: 'address',
        name: 'address',
        edit: true,
    },
    loyaltyHistory: {
        title: 'Loyalty History',
        api: 'loyalty-history/cms',
        route: 'loyalty-history',
        name: 'loyalty_history',
        edit: true,
    },
    creditBatch: {
        title: 'Gift Card Batches',
        api: 'creditBatch/cms',
        route: 'credit-batch',
        name: 'credit_batch',
        autocomplete: {
            initializeEmpty: true,
            foreign_key: true,
        }
    },
    credit: {
        title: 'Gift Cards',
        api: 'credit/cms',
        route: 'credit-code',
        name: 'credit',
        edit: true,
    },
    customer: {
        title: 'Customers',
        api: 'customer/cms',
        route: 'customers',
        name: 'customer',
        back: true,
        edit: true,
        jumper: { },
        autocomplete: {
            bindLabel: 'ship_firstname',
            initializeEmpty: false,
            foreign_key: true,
        }
    },
    toolbar: {
        title: 'Toolbars',
        api: 'toolbar/cms',
        route: 'toolbar',
        name: 'toolbar'
    },
    toolbarLink: {
        title: 'Toolbar Links',
        api: 'toolbar-link/cms',
        route: 'toolbar-link',
        name: 'toolbar_link',
    },
    footer: {
        title: 'Footers',
        api: 'footer/cms',
        route: 'footer',
        name: 'footer'
    },
    footerLink: {
        title: 'Footer Links',
        api: 'footer-link/cms',
        route: 'footer-link',
        name: 'footer_link',
    },
    loyaltyRewards: {
        title: 'Loyalty Rewards',
        api: 'loyalty-reward/cms',
        route: 'loyalty-reward',
        name: 'loyalty_reward',
        edit: true,
    },
    loyaltyProductInstance: {
        title: 'Loyalty Redemptions',
        api: 'loyalty-product-instance/cms',
        route: 'loyalty-product-instance',
        name: 'loyalty_product_instance',
    },
    webpage: {
        title: 'Webpages',
        api: 'webpage/cms',
        name: 'webpage',
        route: 'webpages',
        edit: true,
        jumper: { },
        autocomplete: {
            path: 'webpage/cms',
            bindLabel: 'webpage_title',
            placeholder: 'Select a Webpage',
            initializeEmpty: true,
            foreign_key: true
        }
    },
    webpageArray: {
        title: 'Webpage Arrays',
        api: 'webpage-array/cms',
        route: 'webpage-array',
        name: 'webpage_array',
    },
    webpageTimeline: {
        title: 'Webpage Timelines',
        api: 'webpage-timeline/cms',
        route: 'webpage-timeline',
        name: 'webpage_timeline',
    },
    presavePage: {
        title: 'Presave Pages',
        api: 'presave-page/cms',
        route: 'presave',
        name: 'presave',
        edit: true,
        jumper: { },
    },
    albumTracks: {
        title: 'Album Tracks',
        api: 'album-track/cms',
        route: 'album-track',
        name: 'album_track',
    },
    album: {
        title: 'Albums',
        api: 'album/cms',
        route: 'albums',
        name: 'album',
        autocomplete: {
            path: 'album',
            placeholder: 'Select an Album',
            bindLabel: 'album',
            initializeEmpty: false,
            foreign_key: true,
        },
        edit: true,
        newScreenAdd: true,
        back: true,
        jumper: { },
    },
    automator: {
        title: 'Automators',
        api: 'automator/cms',
        name: 'automator',
        route: 'automators',
        edit: true,
        jumper: { },
        autocomplete: {
            initializeEmpty: true,
            foreign_key: true
        }
    },
    account: {
        title: 'Account',
        api: 'account/cms',
        name: 'account',
        route: 'account',
        edit: true
    },
    accountGlobals: {
        title: 'Account',
        api: 'account/cms',
        name: 'account',
        route: 'account',
        edit: true
    },
    accountEmail: {
        title: 'Email Settings',
        api: 'account-email/cms',
        name: 'account-email',
        route: 'account-email',
        edit: true
    },
    accountKeys: {
        title: 'Account Keys',
        api: 'account-keys/cms',
        name: 'account_keys',
        route: 'account-keys',
        edit: true
    },
    artistProdList: {
        title: 'Artist Product List',
        api: 'artist-prod-list-group/cms',
        name: 'artist_prod_list_group',
        route: 'artist-prod-list',
        newScreenAdd: true,
    },
    news: {
        title: 'News',
        api: 'news/cms',
        name: 'news',
        route: 'news',
        autosave: true,
        newScreenAdd: true,
        edit: true,
        back: true,
        jumper: { },
        autocomplete: {
            foreign_key: true,
        }
    },
    newsProduct: {
        title: 'News Product',
        api: 'news-product/cms',
        name: 'news_product',
    },
    automatorType: {
        api: 'automator-type/cms',
        name: 'automator_type',
        route: 'automator-type',
        title: 'Automator Types'
    },
    banner: {
        title: 'Banners',
        api: 'banner/cms',
        route: 'banners',
        name: 'banner',
        autocomplete: {
            path: 'banner',
            placeholder: 'Select a Banner',
            initializeEmpty: true,
            foreign_key: true,
        }
    },
    publisherTrack: {
        title: 'Publisher Tracks',
        api: 'publisher-track/cms',
        route: 'publisher-track',
        name: 'publisher_track',
    },
    track: {
        title: 'Tracks',
        api: 'track/cms',
        route: 'tracks',
        autocomplete: {
            path: 'track',
            placeholder: 'Select a Track',
            initializeEmpty: true,
            minLength: 2,
            foreign_key: true,
            bindLabel: 'track',
        },
        newScreenAdd: true,
        name: 'track',
        edit: true,
        back: true,
        jumper: { },
    },
    storePageItem: {
        title: 'Store Page Items',
        api: 'store-page-item/cms',
        route: 'store-pages-item',
        name: 'store_page_item',
        edit: true
    },
    storePage: {
        title: 'Store Pages',
        api: 'store-page/cms',
        name: 'store_page',
        route: 'store-pages',
        edit: true,
        jumper: { },
    },
    artist: {
        title: 'Artists',
        api: 'artist/cms',
        route: 'artists',
        name: 'artist',
        autocomplete: {
            path: 'artist',
            placeholder: 'Select an Artist',
            bindLabel: 'name',
            foreign_key: true,
        },
        newScreenAdd: true,
        edit: true,
        back: true,
        jumper: { },
    },
    type: {
        title: 'Types',
        api: 'type/cms',
        name: 'type',
        route: 'types',
        newScreenAdd: true,
        edit: true,
        autocomplete: {
            placeholder: 'Select a Type',
            initializeEmpty: true,
            foreign_key: true,
        }
    },
    order: {
        title: 'Orders',
        api: 'order/cms',
        name: 'order',
        route: 'orders',
        edit: true,
        jumper: {
            useId: true
        }
    },
    soundscanSettings: {
        title: 'Soundscan Settings',
        api: 'soundscan-settings/cms',
        route: 'soundscan-settings',
        name: 'soundscan_settings',
    },
    orderNotes: {
        name: 'order_note',
        title: 'Order Notes',
        api: 'order-note/cms',
        route: 'orderNote',
    },
    taxAndShipping: {
        name: 'tax_and_shipping',
        api: 'tax-and-shipping/cms',
        title: 'Tax And Shipping',
        route: 'taxAndShipping',
    },
    shippingLabel: {
        title: 'Shipping Label',
        name: 'shipping_label',
        api: 'shippingLabel/cms',
        route: 'shipping-label',
        autocomplete: {
            placeholder: 'Select a Shipping Method',
            foreign_key: true,
            initializeEmpty: true
        }
    },
    shippingRate: {
        title: 'Shipping Rates',
        name: 'shipping_rate',
        api: 'shipping-rate/cms',
        route: 'shipping-rate',
        edit: true,
        newScreenAdd: true,
        autocomplete: {
            placeholder: 'Select a Shipping Method',
            foreign_key: true,
            initializeEmpty: true
        }
    },
    orderShipment: {
        title: 'Order Shipments',
        name: 'order_shipment',
        api: 'order-shipment/cms',
        route: 'orderShipment',
        autocomplete: {
            placeholder: 'Select a Shipment',
            foreign_key: true,
            initializeEmpty: true,
        }
    },
    transaction: {
        name: 'order_transaction',
        api: 'order-transaction/cms',
        title: 'Order Transactions',
        route: 'order-transactions'
    },
    downloadLog: {
        name: 'download_log',
        api: 'downloadLog/cms',
        title: 'Download Logs',
        route: 'download-log',
    },
    codeBatch: {
        name: 'code_batch',
        api: 'code-batch/cms',
        title: 'Code Batch',
        route: 'code-batch',
        newScreenAdd: true
    },
    downloadCode: {
        name: 'download_code',
        api: 'download-code/cms',
        title: 'Download Code',
        route: 'download-code'
    },
    orderProductInstance: {
        name: 'order_product_instance',
        api: 'order-product-instance/cms',
        title: 'Order Product Instances',
        route: 'orderProductInstance',
        autocomplete: {
            placeholder: 'Select an Order Item',
            foreign_key: true,
            initializeEmpty: true,
        }
    },
    product: {
        title: 'Products',
        api: 'product/cms',
        name: 'product',
        route: 'products',
        newScreenAdd: true,
        edit: true,
        back: true,
        autocomplete: {
            placeholder: 'Select a Product',
            bindLabel: 'title',
            foreign_key: true,
            path: 'product'
        },
        jumper: { },
    },
    productInstance: {
        title: 'Product Instances',
        api: 'productInstance/cms',
        name: 'product_instance',
        route: 'productInstances',
        newScreenAdd: true,
        edit: true,
        back: true,
        autocomplete: {
            placeholder: 'Select a Product Instance',
            foreign_key: true,
            path: 'productInstance',
            initializeEmpty: false,
        },
        jumper: { },
    },
    bundle: {
        title: 'Bundles',
        api: 'bundle/cms',
        route: 'bundle',
        name: 'bundle',
        edit: true,
        newScreenAdd: true,
        autocomplete: {
            placeholder: 'Select a Bundle',
            bindLabel: 'title',
            foreign_key: true,
            path: 'bundle'
        }
    },
    pressquote: {
        title: 'Pressquotes',
        api: 'pressquote/cms',
        name: 'pressquote',
        route: 'pressquote',
        autocomplete: {
            placeholder: 'Select a Press Quote',
            bindLabel: 'pressquote',
            foreign_key: true,
            path: 'pressquote'
        },
        jumper: { },
    },
    productPhoto: {
        title: 'Product Photos',
        api: 'productPhoto/cms',
        name: 'product_photo',
        route: 'productPhoto',
        autocomplete: {
            placeholder: 'Select a Product Photo',
            bindLabel: 'productPhoto',
            foreign_key: true,
            path: 'productPhoto'
        },
        jumper: { },
    },
    artistPhoto: {
        title: 'Artist Photos',
        api: 'artist-photo/cms',
        route: 'artistPhoto',
        name: 'artist_photo'
    },
    albumPhoto: {
        title: 'Album Photos',
        api: 'album-photo/cms',
        route: 'albumPhoto',
        name: 'album_photo',
    },
    photo: {
        api: 'photo',
        route: 'photos',
        title: 'Photoss',
        name: 'photos',
    },
    linktree: {
        title: 'Linktrees',
        api: 'linktree/cms',
        route: 'linktree',
        name: 'linktree',
        edit: true,
        jumper: { },
    },
    mediaPage: {
      title: 'Media Pages',
      api: 'media-page/cms',
      route: 'media-page',
      name: 'media_page',
      edit: true,
      jumper: { },
    },
    splash: {
        title: 'Splash Pages',
        api: 'splash/cms',
        name: 'splash',
        route: 'splash',
        newScreenAdd: true,
        edit: true,
        jumper: { },
        autocomplete: {
            placeholder: 'Select a Splash Page',
            bindLabel: 'splash',
            foreign_key: true,
            path: 'splash/cms',
        }
    },
    artistFeaturedProduct: {
      title: 'Artist Featured Products',
      api: 'artist-featured-product/cms',
      route: 'artistFeaturedProduct',
      name: 'artist_featured_product',
    },
    artistLink: {
      title: 'Links',
      api: 'link/cms',
      route: 'artistLinks',
      name: 'artist_link'
    },
    artistPageAlbums: {
      title: 'Artist Page Albums',
      api: 'artist-page-album/cms',
      route: 'artistPageAlbums',
      name: 'artist_page_album',
    },
    artistPerson: {
      title: 'Artist Persons',
      api: 'artist-person/cms',
      route: 'artistPerson',
      name: 'artist_person',
    },
    artistPressroom: {
      title: 'Pressroom',
      api: 'pressroom/cms',
      route: 'artistPressroom',
      name: 'artist_pressroom'
    },
    artistTracks: {
      title: 'Artist Tracks',
      api: 'artist-track/cms',
      route: 'artistTracks',
      name: 'artist_tracks',
    },
    relatedProduct: {
      title: 'Related Products',
      api: 'related-product/cms',
      route: 'relatedProducts',
      name: 'related',
    },
    overlay: {
      title: 'Overlays',
      api: 'overlay/cms',
      route: 'overlay',
      name: 'overlay',
      autocomplete: {
          placeholder: 'Select an Overlay',
          bindLabel: 'overlay',
          foreign_key: true,
          path: 'overlay/cms',
          initializeEmpty: true
      }
    },
    extraData: {
      title: 'Extra Datas',
      api: 'extra-data/cms',
      route: 'extra-data',
      name: 'extra_data',
      addScreen: true,
      autocomplete: {
          placeholder: 'Select Extra Data',
          bindLabel: 'extraData',
          foreign_key: true,
          path: 'extraData/cms',
          initializeEmpty: true
      },
      jumper: {}
    },
    vendor: {
      title: 'Vendors',
      api: 'vendor/cms',
      route: 'vendor',
      name: 'vendor',
      addScreen: true,
      edit: true,
      autocomplete: {
          placeholder: 'Select Vendor',
          bindLabel: 'vendor',
          foreign_key: true,
          path: 'vendor/cms'
      },
      jumper: {}
    },
    wholesalePrice: {
      title: 'Wholesale Prices',
      api: 'wholesale-price/cms',
      route: 'wholesale-price',
      name: 'ws_price',
      edit: true,
      addScreen: true,
      autocomplete: {
          placeholder: 'Select Wholesale Price',
          bindLabel: 'wholesalePrice',
          foreign_key: true,
          initializeEmpty: true,
          path: 'wholesalePrice/cms'
      },
      jumper: {}
    },
    person: {
      title: 'Persons',
      api: 'person/cms',
      route: 'person',
      name: 'person',
      edit: true,
      addScreen: true,
      autocomplete: {
          placeholder: 'Select People',
          bindLabel: 'person',
          foreign_key: true,
          path: 'person/cms'
      },
      jumper: {}
    },
    personRole: {
      title: 'Person Roles',
      api: 'person-role/cms',
      route: 'person-role',
      name: 'person_role',
      addScreen: true,
      edit: true,
      autocomplete: {
          placeholder: 'Select a Person Role',
          bindLabel: 'personRole',
          foreign_key: true,
          initializeEmpty: true,
          path: 'personRole/cms'
      },
      jumper: {}
    },
    country: {
        title: 'Countries',
        api: 'country/cms',
        route: 'country',
        name: 'country',
        autocomplete: {
            placeholder: 'Select a Country',
            bindLabel: 'name',
            initializeEmpty: true,
            foreign_key: true,
        }
    },
    countryId: {
        title: 'Countries',
        api: 'country-id/cms',
        route: 'country',
        name: 'country',
        autocomplete: {
            placeholder: 'Select a Country',
            bindLabel: 'name',
            initializeEmpty: true,
            foreign_key: true,
        }
    },
    recordLabel: {
        title: 'Record Labels',
        api: 'record-label/cms',
        route: 'record-label',
        name: 'record_label',
        edit: true,
        addScreen: true,
        autocomplete: {
            placeholder: 'Select a Record Label',
            bindLabel: 'name',
            initializeEmpty: true,
            foreign_key: true,
        }
    },
    customerTag: {
        title: 'Customer Tags',
        api: 'customer-tag/cms',
        route: 'customer-tag',
        name: 'customer_tag',
        autocomplete: {
            placeholder: 'Select a Tag',
            bindLabel: 'name',
            initializeEmpty: true,
            foreign_key: true,
        }
    },
    customerIncludeTag: {
        title: 'Customer Include Tags',
        api: 'customer-include-tag/cms',
        route: 'customer-include-tag',
        name: 'customer_include_tag',
        autocomplete: {
            placeholder: 'Select a Customer Include Tag',
            bindLabel: 'name',
            initializeEmpty: true,
            foreign_key: true,
        }
    },
    customerExcludeTag: {
        title: 'Customer Exclude Tags',
        api: 'customer-exclude-tag/cms',
        route: 'customer-exclude-tag',
        name: 'customer_exclude_tag',
        autocomplete: {
            placeholder: 'Select a Customer Exclude Tag',
            bindLabel: 'name',
            initializeEmpty: true,
            foreign_key: true,
        }
    },
    declinedTransaction: {
        title: 'Declined Transactions',
        api: 'declined-transaction/cms',
        route: 'declined-transaction',
        name: 'declined_transaction',
        autocomplete: {
            placeholder: 'Select a Transaction',
            bindLabel: 'name',
            foreign_key: true,
        }
    },
    trackMedia: {
        title: 'Track Media',
        api: 'track-media/cms',
        route: 'track-media',
        name: 'track_media',
        autocomplete: {
            placeholder: 'Select a Track Media',
            bindLabel: 'filename',
            foreign_key: true,
        }
    },
    albumMedia: {
        title: 'Album Media',
        api: 'album-media/cms',
        route: 'album-media',
        name: 'album_media',
        autocomplete: {
            placeholder: 'Select a Album Media',
            bindLabel: 'filename',
            foreign_key: true,
        }
    },
    productDetailPage: {
        title: 'Product Page Layout',
        api: 'product-detail-page/cms',
        route: 'product-detail-page',
        name: 'product_detail_page',
    },
    pageLayout: {
        title: 'Page Layout',
        api: 'page-layout/cms',
        route: 'page-layout',
        name: 'page_layout',
        edit: true,
    },
    homePageLayout: {
        title: 'Home Page Layout',
        api: 'home-page-layout/cms',
        route: 'home-page-layout',
        name: 'home_page_layout',
    },
    artistPageLayout: {
        title: 'Artist Page Layout',
        api: 'artist-page-layout/cms',
        route: 'artist-page-layout',
        name: 'artist_page_layout',
    },
    prodList: {
        title: 'Product List',
        api: 'prod-list/cms',
        route: 'prod-list',
        name: 'prod_list',
        edit: true,
        newScreenAdd: true,
        autocomplete: {
            placeholder: 'Select a Product List',
            foreign_key: true,
            initializeEmpty: true
        }
    },
    prodListGroup: {
        title: 'Product List Group',
        api: 'prod-list-group/cms',
        route: 'prod-list-group',
        name: 'prod_list_group',
    },
    prodListGroupFilter: {
        title: 'Pro List Group Filter',
        api: 'prod-list-group-filter/cms',
        route: 'prod-list-group-filter',
        name: 'prod_list_group_filter',
    },
    sale: {
        title: 'Sale',
        api: 'sale/cms',
        route: 'sale',
        name: 'sale',
        edit: true
    },
    couponBatch: {
        title: 'Coupon Batch',
        api: 'coupon-batch/cms',
        route: 'coupon-batch',
        name: 'coupon_batch',
        edit: true,
        autocomplete: {
            placeholder: 'Select a Coupon Batch',
            foreign_key: true,
            initializeEmpty: true
        }
    },
    coupon: {
        title: 'Coupon',
        api: 'coupon/cms',
        route: 'coupon',
        name: 'coupon',
        addScreen: true,
        edit: true,
        autocomplete: {
            placeholder: 'Select a Coupon',
            foreign_key: true,
            initializeEmpty: true
        }
    },
    couponProdList: {
        title: 'CouponProdList',
        api: 'coupon-prod-list/cms',
        route: 'coupon-prod-list',
        name: 'coupon_prod_list',
    },
    bundleGroup: {
        title: 'Bundle Group',
        api: 'bundle-group/cms',
        route: 'bundle-group',
        name: 'bundle_group',
    },
    bundlePhoto: {
        title: 'Bundle Photo',
        api: 'bundle-photo/cms',
        route: 'bundle-photo',
        name: 'bundle_photo',
    },
    productOption: {
        title: 'Product Option',
        api: 'product-option/cms',
        route: 'product-option',
        name: 'product_option',
        autocomplete: {
            placeholder: 'Select a Product Option',
            foreign_key: true,
            initializeEmpty: true
        }

    },
    productOptionValue: {
        title: 'Product Option Value',
        api: 'product-option-value/cms',
        route: 'product-option-value',
        name: 'product_option_value',
        autocomplete: {
            placeholder: 'Select a Product Option',
            foreign_key: true,
            initializeEmpty: true
        }
    },
    productOptionValueXref: {
        title: 'Product Option Value',
        api: 'product-option-value-xref/cms',
        route: 'product-option-value-xref',
        name: 'product_option_value_xref',
        autocomplete: {
            placeholder: 'Select a Product Option',
            foreign_key: true,
            initializeEmpty: true
        }
    },
    user: {
        title: 'User',
        api: 'user/cms',
        route: 'user',
        name: 'user',
    },
    territory: {
        title: 'Territory',
        api: 'territory/cms',
        route: 'territory',
        name: 'territory',
        checkboxTree: {
            placeholder: 'Select territories',
            foreign_key: true,
            initializeEmpty: true,
        },
    },
}
